import type React from 'react'
import type { IconProps } from './types'

const EditSquare: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H13.925L11.925 5H5V19H19V12.05L21 10.05V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM9 15V10.75L18.175 1.575C18.375 1.375 18.6 1.225 18.85 1.125C19.1 1.025 19.35 0.974998 19.6 0.974998C19.8667 0.974998 20.1208 1.025 20.3625 1.125C20.6042 1.225 20.825 1.375 21.025 1.575L22.425 3C22.6083 3.2 22.75 3.42083 22.85 3.6625C22.95 3.90417 23 4.15 23 4.4C23 4.65 22.9542 4.89583 22.8625 5.1375C22.7708 5.37917 22.625 5.6 22.425 5.8L13.25 15H9ZM11 13H12.4L18.2 7.2L17.5 6.5L16.775 5.8L11 11.575V13Z' />
	</svg>
)

export default EditSquare
